import { apiRequest } from 'utils/api';

const sharedUrl = process.env.REACT_APP_SHARED_API_URL;
const businessUrl = process.env.REACT_APP_BUSINESS_WEB_URL;

const LOAD_NAV_PRODUCTS = 'shared/LOAD_NAV_PRODUCTS';

export const loadNavProducts = () => async dispatch => {
  const url = sharedUrl + `/navigation/urlsforuser?businessWebBaseUrl=${businessUrl}`;
  const data = await apiRequest(url);
  if (!data.error) {
    dispatch({ type: LOAD_NAV_PRODUCTS, data });
  }
  return data;
};

export const setNavigationItems = products => dispatch => {
  dispatch({
    type: LOAD_NAV_PRODUCTS,
    data: products
  });
};

const initialState = {
  navigation: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_NAV_PRODUCTS:
      return { ...state, navigation: action.data };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/jsx/ducks/shared.js